import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MaterialIcon } from './MaterialIcon';
import { ChatDrawer, DrawerShell } from './game/GameMenu';
import { RoomManagement } from './RoomManagement';
import { useGame } from '../state/gameContext';

interface MobileBottomNavProps { active?: string; }

export function MobileBottomNav({ active }: MobileBottomNavProps) {
  const { state } = useGame();
  const [panel, setPanel] = useState<'players' | 'chat' | null>(null);
  const gamePath = !state.roomCode ? '/' : state.phase === 'judging' ? '/judge' : state.phase === 'roundResult' ? '/round-winner' : state.phase === 'gameOver' ? '/game-over' : state.phase === 'lobby' ? '/lobby' : '/game';
  const close = () => setPanel(null);
  const itemClass = 'flex flex-col items-center justify-center min-w-16 min-h-12 text-on-surface-variant hover:text-primary';
  return <>
    <nav aria-label="Game navigation" className="md:hidden fixed bottom-0 left-0 w-full z-[60] flex justify-around items-center h-20 px-4 bg-surface-container border-t border-white/10">
      <Link to={gamePath} className={`${itemClass} ${active === '/game' ? 'text-primary' : ''}`}><MaterialIcon name="playing_cards" /><span className="text-xs">Game</span></Link>
      <button type="button" className={itemClass} data-testid="mobile-players" onClick={() => setPanel('players')}><MaterialIcon name="groups" /><span className="text-xs">Players</span></button>
      <button type="button" className={itemClass} data-testid="mobile-chat" onClick={() => setPanel('chat')}><MaterialIcon name="chat_bubble" /><span className="text-xs">Chat</span></button>
    </nav>
    {panel === 'players' && <DrawerShell title="Players" icon="groups" testId="players-panel" onClose={close}><div className="overflow-y-auto min-h-0">{state.roomCode ? <RoomManagement /> : <p>Join a room to see the players.</p>}</div></DrawerShell>}
    {panel === 'chat' && <ChatDrawer onClose={close} />}
  </>;
}
